module.exports = __webpack_public_path__ + "assets/img/hill-4.5d5e5459.png";